export default __webpack_public_path__ + "static/media/HouseOne.0d5d5674.jpg";